// toggle_controller.js
import { Controller } from "stimulus";
import Tribute from "tributejs";
import Trix from "trix";

export default class extends Controller {
  static targets = ["field"];

  connect() {
    this.editor = this.fieldTarget.editor
    this.initializeTribute()
  }

  disconnect() {
    this.tribute.detach(this.fieldTarget)
  }

  initializeTribute() {
    this.tribute = new Tribute({
      trigger: '@',
      allowSpaces: true,
      lookup: 'full_name',
      requireLeadingSpace: true,
      values: this.fetchUsers
    })
    this.tribute.attach(this.fieldTarget)
    this.tribute.range.pasteHtml = this._pasteHtml.bind(this)
    this.fieldTarget.addEventListener('tribute-replaced', this.replaced)
  }

  menuItemTemplate(item) {
    return '<img width="25" height="25" src="'+item.original.image_url + '">' + item.string;
  }

  fetchUsers(text, callback) {
    var url = `/mentions.json?q[full_name_cont]=${text}`,
      trip_id = $('form#new_note input#note_trip_id').val(),
      trip_assignee_id = $('form#new_note input#note_trip_assignee_id').val();

    var wo_selector = $('form#new_note').parents('.work_orders-details');
    if (wo_selector.length > 0) {
      var wo_id = wo_selector.data('page_type_id');
      var target_comp_id = $('form#new_note').parents('#notes_section').find('select#assign_company_id').val();
      if (wo_id) {
        if (target_comp_id.length > 0) {
          url = `/mentions.json?wo_id=${wo_id}&target_comp_id=${target_comp_id}&q[full_name_cont]=${text}`;
        } else {
          url = `/mentions.json?wo_id=${wo_id}&q[full_name_cont]=${text}`;
        }
      }
    }

    if(trip_id){
      url = `/mentions/trip_assignees?q[full_name_cont]=${text}&q[id_eq]=${trip_assignee_id}&trip_id=${trip_id}`;
    }

    fetch(url)
    .then(response => response.json())
    .then(json => callback(json.users))
    .catch(error => callback([]))
  }

  replaced(event) {
    let mention = event.detail.item.original
    let attachment = new Trix.Attachment({
      sgid: mention.sgid,
      content: mention.content
    })
    this.editor.insertAttachment(attachment)
    this.editor.insertString(" ")
  }

  _pasteHtml(html, startPos, endPos) {
    let position = this.editor.getPosition()
    let tributeLength = endPos - startPos
    let trixStartPos = position - tributeLength
    let trixEndPos = position
    this.editor.setSelectedRange([trixStartPos, trixEndPos])
    this.editor.deleteInDirection('backward')
  }

}
